import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { SpecificationsFormulaSettingsComponent } from 'src/app/components/dialog';
import { Lang, FileData, Res } from 'src/app/models';
import { NotificationService, DialogModalService, ValidatorsService, LanguageService } from 'src/app/services';
import { ApispecificationService } from 'src/app/services/api-specifications.service';
import { SpecificationsActionsValidator } from '../specifications-actions-validator';

@Component({
  selector: 'app-specifications-edit',
  templateUrl: './specifications-edit.component.html',
  styleUrls: ['./specifications-edit.component.css']
})
export class SpecificationsEditComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  multiple: boolean = false;
  specificationId: string;
  component: string = 'specification';
  specificationName: Lang;
  file: FileData = null;
  errorMessages: any;
  specifications: any[] = [];
  attributes: any[] = [];
  isFormula: boolean[] = [];
  formula: any[] = [];
  formulaForEdit: any[] = [];
  readonly: any[] = [];
  formats: any[] = [
    {
      id: 'text',
      name: 'Текстовое'
    },
    {
      id: 'number',
      name: 'Числовое'
    },
    {
      id: 'date',
      name: 'Дата'
    }
  ]
  langs: any[] = [
    {
      id: 'ru',
      name: 'Русский'
    },
    {
      id: 'ne',
      name: 'Английский'
    },
    {
      id: 'kz',
      name: 'Казахский'
    }
  ]
  types: any[] = [
    {
      id: 'attribute',
      name: 'Атрибут'
    },
    {
      id: 'formula',
      name: 'Формула'
    }
  ]

  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }

  form: UntypedFormGroup = this.fb.group({
    id: [null],
    name: [null, Validators.required],
    specifications: this.fb.array([])
  });

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    private apiSpecificationsService: ApispecificationService,
    private languageService: LanguageService,
    private notification: NotificationService,
    private dialogModal: DialogModalService,
    private validator: SpecificationsActionsValidator,
    private validatorService: ValidatorsService,
    private currentRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.errorMessages = this.validator.errorMessages;

    this.specificationId = this.currentRoute.snapshot.paramMap.get('id');

    this.onEdit();
  }

  /**
   * 
   * @param fieldName 
   * @param value 
   */
  eventFnFF(fieldName: string, value: Lang): void {

    this.form.controls[fieldName].setValue(value);
  }

  /**
   * 
   * 
   */
  addFilterFields(): void {

    let control = this.form.controls.specifications as UntypedFormArray;
    control.push(this.initFilterField(control.length));
  }

  /**
  * 
  * @param i number
  */
  removeFilterField(index: number): void {

    let control = this.form.controls.specifications as UntypedFormArray;
    control.removeAt(index);

    //так же чистим переменные для проверки отрисовки кнопки добавления/информации формулы
    this.isFormula[index] = false;
    this.formula[index] = null;

    for (let i = 0; i < control.length; i++) {

      // this.onListenerType(i);

      this.form.get(['specifications', i, 'field']).setValue(i + 1);

      // this.onListenerAttribute(i);

    }
  }

  /**
  * 
  * 
  */
  initFilterField(index: number): any {

    return this.fb.group({
      field: [index + 1],
      column_name: [null, this.validator.field],
      type: [null, this.validator.type],
      requirement: [null, this.validator.requirement],
      lang_code: [null]
    });

  }

  /**
   * 
   */
  onListenerType(index: number) {

    let currentVal = this.form.get(['specifications', index, 'type']).value;

    currentVal != null && currentVal == 'formula' ? this.isFormula[index] = true : this.isFormula[index] = false;

    if (currentVal == 'attribute') {

      this.getAttirbutes();
      this.onListenerAttribute(index);
    }
  }

  /**
   * 
   */
  onListenerAttribute(index: number) {

    let currentVal = this.form.get(['specifications', index, 'requirement']).value;

    console.log("CURRENT VAL: ", currentVal);

    if (currentVal != null && !currentVal.multilang) {

      this.form.get(['specifications', index, 'lang_code']).setValue(null)
    }

    if (currentVal != null) {

      this.readonly[index] = currentVal.multilang

    }

  }

  /**
  * 
  */
  getAttirbutes(): void {

    this.progressRef.start();

    let data = {
      ref_name: "attr_spec_list",
      filter: {
        ref_type: "ATTRIBUTE"
      }
    }

    this.subscriptions.add(
      this.apiSpecificationsService.getReferences(data, data.ref_name).subscribe((response: Res) => {
        console.log('[RESPONSE] getTypesActions: ', response);

        if (response != null && response.result != null) {

          this.attributes = response.result;

        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }



  /**
  * 
  */
  onCreateFormula(index: number) {

    this.loading = true;

    let data = null;

    this.dialogModal.open(data, SpecificationsFormulaSettingsComponent, 'xl').then(

      (result) => {

        if (result) {

          this.convertFormulaData(result, index);
        }

        this.loading = false;
      },
      () => { console.log('Rejected!'); }
    );

  }

  /**
   * 
   * @param index 
   */
  onEditFormula(index: number) {

    this.loading = true;

    let formula_fields_for_edit: any[] = [];

    console.log("FORM CONTROL: ", this.form.controls.specifications.value[index].requirement);

    for (let f of this.form.controls.specifications.value[index].requirement) {

      formula_fields_for_edit.push({

        id: null,
        type_field: {
          id: f.type,
          name: this.checkTypes(f.type),
          input_type: f.type == 'ATTRIBUTE' || f.type == 'OPERATOR' ? 'COMBOBOX' : f.type
        },
        value_type: f.id ? { id: f.id, name: f.name } : f.name,
        lang_code: f.lang_code
      })
    }


    let data = {
      isFormulaEdit: true,
      formulaForEdit: this.formulaForEdit[index] ? this.formulaForEdit[index] : formula_fields_for_edit
    }

    console.log("FORMULA FOR EDIT:", data);


    this.dialogModal.open(data, SpecificationsFormulaSettingsComponent, 'xl').then(

      (result) => {

        if (result) {

          this.convertFormulaData(result, index);
        }

        this.loading = false;
      },
      () => { console.log('Rejected!'); }
    );

  }

  /**
  * 
  * @param formula 
  */
  convertFormulaData(formulaFormValue: any, index: number) {

    let formula_fields_for_create: any[] = [];

    for (let i = 0; i < formulaFormValue.length; i++) {

      formula_fields_for_create.push({

        id: formulaFormValue[i].value_type.id,
        name: formulaFormValue[i].value_type.name ? formulaFormValue[i].value_type.name : formulaFormValue[i].value_type,
        type: formulaFormValue[i].type_field.id ? formulaFormValue[i].type_field.id : null,
        lang_code: formulaFormValue[i].lang_code

      });

    }

    console.log("FORMULA RESULT: ", formula_fields_for_create);

    this.formula[index] = formula_fields_for_create;
    this.formulaForEdit[index] = formulaFormValue;
    this.form.get(['specifications', index, 'requirement']).setValue(formula_fields_for_create);

  }

  /**
   * 
   * @param type 
   */
  checkTypes(type: string) {

    let name: string = '';

    switch (type) {

      case 'ATTRIBUTE':

        name = 'Атрибуты';
        break;

      case 'TEXTBOX':

        name = 'Текстовая константа';
        break;

      case 'NUMERIC':

        name = 'Числовая константа';
        break;

      case 'OPERATOR':

        name = 'Оператор'
        break;

    }

    return name;

  }

  /**
   * 
   * @param i 
   */
  removeFormulaField(i: number): void {

    this.formula[i] = null;
  }


  /**
   * 
   */
  onEdit() {

    this.progressRef.start();
    this.loading = true;

    let data = {

      id: +this.specificationId

    }

    this.subscriptions.add(

      this.apiSpecificationsService.getList(data).subscribe((response: Res) => {
        console.log('[RESPONSE] SPEC_EDIT_DATA: ', response);

        if (response != null) {

          this.setDataInForm(response.result);
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );

  }

  /**
   * 
   * @param fileData 
   */
  setDataInForm(specificationData) {

    if (specificationData != null) {

      this.form.get('id').setValue(+this.specificationId);

      this.form.get('name').setValue(specificationData.name);

      this.specificationName = specificationData.name;

      specificationData.specification_body.forEach((element, index) => {

        this.addSpecFieldsWithdata(element, index);
      });
    }
  }

  /**
  * 
  * @param type string
  */
  addSpecFieldsWithdata(specData: any, index: number): void {

    console.log("SPEC DATA: ", specData);

    if (specData.type == 'formula') {

      this.isFormula[index] = true;
      this.formula[index] = specData.requirement;
    }

    let control = this.form.controls.specifications as UntypedFormArray;
    control.push(this.setSpecData(specData, index));

    this.onListenerType(index);
  }

  /**
  * 
  * @param referenceData 
  * @returns 
  */
  setSpecData(specData: any, index: number) {

    return this.fb.group({
      field: [+specData.field],
      column_name: [specData.column_name, this.validator.field],
      type: [specData.type, this.validator.type],
      requirement: [specData.type == 'attribute' ? { id: specData.requirement[0].id, name: specData.requirement[0].name } : specData.requirement, this.validator.requirement],
      lang_code: [specData.type == 'attribute' && specData.lang_code != null ? specData.requirement[0].lang_code : null]
    });
  }

  /**
   * 
   */
  onUpdate() {

    let form = { ...this.form.value };

    let control = this.form.controls.specifications as UntypedFormArray;

    for (let i = 0; i < control.value.length; i++) {

      if (control.value[i].type == "attribute") {

        control.value[i].requirement = [{

          type: "attribute",
          id: control.value[i].requirement.id,
          name: control.value[i].requirement.name,
          lang_code: control.value[i].lang_code

        }]

      }

    }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiSpecificationsService.create(form).subscribe((response: Res) => {
        console.log('[RESPONSE] UPDATE_CHANNEL: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          // this.onEdit();
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );

  }

  /**
  * 
  * @param field 
  * @param type 
  */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }

}
